const styles = {
  "mt-0": "_mt-0_1jxbs_2",
  "mt-1": "_mt-1_1jxbs_6",
  "mt-2": "_mt-2_1jxbs_10",
  "mt-3": "_mt-3_1jxbs_14",
  "mt-4": "_mt-4_1jxbs_18",
  "mt-5": "_mt-5_1jxbs_22",
  "mt-6": "_mt-6_1jxbs_26",
  "mt-7": "_mt-7_1jxbs_30",
  "mt-8": "_mt-8_1jxbs_34",
  "mt-9": "_mt-9_1jxbs_38",
  "mt-10": "_mt-10_1jxbs_42",
  "mt-11": "_mt-11_1jxbs_46",
  "mr-0": "_mr-0_1jxbs_51",
  "mr-1": "_mr-1_1jxbs_55",
  "mr-2": "_mr-2_1jxbs_59",
  "mr-3": "_mr-3_1jxbs_63",
  "mr-4": "_mr-4_1jxbs_67",
  "mr-5": "_mr-5_1jxbs_71",
  "mr-6": "_mr-6_1jxbs_75",
  "mr-7": "_mr-7_1jxbs_79",
  "mr-8": "_mr-8_1jxbs_83",
  "mr-9": "_mr-9_1jxbs_87",
  "mr-10": "_mr-10_1jxbs_91",
  "mr-11": "_mr-11_1jxbs_95",
  "mb-0": "_mb-0_1jxbs_100",
  "mb-1": "_mb-1_1jxbs_104",
  "mb-2": "_mb-2_1jxbs_108",
  "mb-3": "_mb-3_1jxbs_112",
  "mb-4": "_mb-4_1jxbs_116",
  "mb-5": "_mb-5_1jxbs_120",
  "mb-6": "_mb-6_1jxbs_124",
  "mb-7": "_mb-7_1jxbs_128",
  "mb-8": "_mb-8_1jxbs_132",
  "mb-9": "_mb-9_1jxbs_136",
  "mb-10": "_mb-10_1jxbs_140",
  "mb-11": "_mb-11_1jxbs_144",
  "ml-0": "_ml-0_1jxbs_149",
  "ml-1": "_ml-1_1jxbs_153",
  "ml-2": "_ml-2_1jxbs_157",
  "ml-3": "_ml-3_1jxbs_161",
  "ml-4": "_ml-4_1jxbs_165",
  "ml-5": "_ml-5_1jxbs_169",
  "ml-6": "_ml-6_1jxbs_173",
  "ml-7": "_ml-7_1jxbs_177",
  "ml-8": "_ml-8_1jxbs_181",
  "ml-9": "_ml-9_1jxbs_185",
  "ml-10": "_ml-10_1jxbs_189",
  "ml-11": "_ml-11_1jxbs_193"
};
const spacingHelper = (classes) => {
  if (!classes) return null;
  return classes.map((cls) => styles[cls]).filter(Boolean).join(" ");
};
export {
  spacingHelper
};
